import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ipGet, ipError } from "../api";
import { PlannerError } from "../components/PlannerState";
import { Card, PageHeader, KpiRow } from "../../components/dc";

// Phase-1 overview: latest run + inputs freshness + quick links. Accuracy and
// alerts cards arrive in later phases.
export default function Landing() {
  const [run, setRun] = useState(null);
  const [batches, setBatches] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([ipGet("/runs/latest"), ipGet("/inputs/batches")]).then(([d, b]) => { setRun(d?.id ? d : null); setBatches(b.batches || []); }).catch(e => setError(ipError(e))).finally(() => setLoading(false));
  }, []);

  const active = batches.filter((b) => b.status === "active");
  const kpis = [
    { label: "Latest run", value: run ? run.label : "none" },
    { label: "Forecast lines", value: run ? Number(run.line_count).toLocaleString() : "—" },
    { label: "Active inputs", value: String(active.length) },
    { label: "Unmapped regions", value: run ? String((run.unmapped_regions || []).length) : "—" },
  ];

  return (
    <div data-testid="ip-overview-page" style={{ minWidth: 0 }}>
      <PageHeader title="Inventory Planner" subtitle="Turns the install forecast into part demand by DC and week. Proof of concept." />
      <PlannerError message={error} testId="ip-overview-error" />
      {loading ? <p role="status" data-testid="ip-overview-loading">Loading planner…</p> : !error && <div data-testid="ip-overview-kpis"><KpiRow items={kpis} cols={4} /></div>}
      <Card style={{ marginTop: 16 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Getting started</div>
        <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9, color: "var(--color-text-2)" }}>
          <li><Link data-testid="ip-overview-inputs-link" to="/ip/inputs">Upload</Link> the install forecast and the usage table.</li>
          <li>Check the assumptions in <Link data-testid="ip-overview-settings-link" to="/ip/settings">Settings</Link> (catch-all, rounding, pick floor).</li>
          <li>Open <Link data-testid="ip-overview-forecast-link" to="/ip/forecast">Forecast</Link> and run it, then export for the ICMs.</li>
        </ol>
      </Card>
    </div>
  );
}
